<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import AppConversation from '@/components/app/conversation.vue';
export default {
  name: 'takeoffAndLandingFilterModal',
  components: { AppTitleHeader, AppConversation },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  computed: {
    baseInfo: function () {
      return [
        {
          id: 1,
          label: 'تاریخ شروع',
          value: this.data?.startDate,
        },
        {
          id: 2,
          label: 'کد گوشی',
          value: this.data?.phoneCode ?? '-',
        },
        {
          id: 3,
          label: 'نوع پایگاه هوایی',
          value: this.data?.typeOfAirStation ?? '-',
        },
        {
          id: 4,
          label: 'علت خروج از فرودگاه',
          value: this.data?.exitReason ?? '-',
        },
        {
          id: 5,
          label: 'شهر مبدا',
          value: this.data?.sourceCity ?? '-',
        },
      ];
    },
    itemFields: function () {
      return [
        {
          label: 'نام فرودگاه خروجی',
          value: 'departureAirport',
        },
        {
          label: 'شهر مقصد',
          value: 'destinationCity',
        },
        {
          label: 'تاریخ خروج',
          value: 'departureDate',
        },
        {
          label: 'تاریخ ورود',
          value: 'arrivalDate',
        },
        {
          label: 'نام فرودگاه ورودی',
          value: 'arrivalAirport',
        },
      ];
    },
  },
  methods: {
    closeModal: function () {
      this.$emit('close-modal');
    },
  },
};
</script>
<template>
  <v-dialog :value="true" width="680" max-height="90dvh">
    <v-card>
      <v-row no-gutters>
        <v-col cols="12" class="modal-header py-2">
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-icon color="darkColor">mdi-document mdi-18px</v-icon>
            <span class="modal-title-text ml-n11">جزییات نشست و برخاست</span>
            <v-spacer></v-spacer>
            <v-icon class="ml-3" @click="closeModal">mdi-close</v-icon>
          </v-row>
        </v-col>
      </v-row>
      <v-card-text class="py-4">
        <v-row no-gutters>
          <v-row>
            <v-col cols="12">
              <app-title-header title="نشست و برخاست در فرودگاه ها" />
            </v-col>
            <v-col cols="6" v-for="{ id, label, value } in baseInfo" :key="id">
              <app-conversation :question="label" :answer="value" />
            </v-col>
            <v-col cols="12">
              <app-title-header title="سایر اطلاعات" />
            </v-col>
            <v-col cols="12">
              <v-expansion-panels :value="0" rounded>
                <v-expansion-panel v-for="(item, index) in data?.items" :key="index">
                  <v-expansion-panel-header>مورد شماره {{ index + 1 }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="6" v-for="({ label, value }, index) in itemFields" :key="index">
                        <app-conversation :question="label" :answer="item?.[value]" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<style lang="css"></style>
